import { render, staticRenderFns } from "./LinkNewTags.vue?vue&type=template&id=081d2789&"
import script from "./LinkNewTags.vue?vue&type=script&lang=js&"
export * from "./LinkNewTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports